import builder from '../builder';
import SocialMediaFacebook from '../../streamline-icons/light/social-media-facebook.svg';
export default builder('IconSocialMediaFacebookLight', SocialMediaFacebook);
//# sourceMappingURL=SocialMediaFacebook.js.map